export const default_state = {
	settings: {
		fontUploadedFile: undefined,
		fontUploadedName: "",
		fontFamily: "",
		fontVariant: "",
		text: "@akashraj9828",
		size: 150,
		unionCheckbox: false,
		separateCheckbox: true,
		bezierAccuracy: "",
		delay: 0.1,
		duration: "",
		strokeWidth: 2,
		fillColor: "#f16f6b",
		strokeColor: "#ffffff",
		timingFunction: "linear",
		repeat: true,
	},
	output: {
		svg: "",
		css: "",
		js: "",
	},
	meta: {
		initialized: false,
	},
};
